import React from 'react';
import { defineMessages } from 'react-intl';

import Text from '../common/Text';
import Translatable from '../common/Translatable';
import List from '../List';
import Picture from '../image/CloudFrontPicture';


defineMessages({
    heading: {
        id: 'HOME_ABOUT_HEADLINE',
        defaultMessage: 'Näh Dir Dein Designerstück!',
        description: 'Headline of the about block on landingpages.',
    },
    subheadline: {
        id: 'HOME_ABOUT_SUBHEADLINE',
        defaultMessage: 'Mit hochwertigen Schnitten & Stoffen aus Berlin.',
        description: 'Subheadline of the about block on landingpages.',
    },
    aboutText: {
        id: 'HOME_ABOUT_SUFFIX',
        defaultMessage: 'Bei uns bekommst Du ein Nähpaket mit:',
        description: 'Header of the about list on landingpages.',
    },
    aboutPrefix: {
        id: 'HOME_ABOUT_PREFIX',
        defaultMessage: 'Alles für perfekte Unikate. Made in Germany.',
        description: 'Prefix of the about list on landingpages.',
    },
    aboutPaperSewpat: {
        id: 'HOME_ABOUT_PAPER_SEWPAT',
        defaultMessage: 'Mehrgrößen-Papierschnitt',
    },
    aboutSewpatHowto: {
        id: 'HOME_ABOUT_SEWPAT_HOWTO',
        defaultMessage: 'Nähanleitung',
    },
    aboutSewpatFabric: {
        id: 'HOME_ABOUT_SEWPAT_Fabric',
        defaultMessage: 'individuell einfärbaren Stoff',
    },
});

const items = [
    <Translatable message='HOME_ABOUT_PAPER_SEWPAT' />,
    <Translatable message='HOME_ABOUT_SEWPAT_HOWTO' />,
    <Translatable message='HOME_ABOUT_SEWPAT_Fabric' />,
];

const About = ({ full }) => (
    <Text colored>
        <Text.Heading
            level={2}
            text={<Translatable message='HOME_ABOUT_HEADLINE' />}
            margin='0.5rem 0 0 0'
            center
        />
        <Text.Heading
            level={6}
            text={<Translatable message='HOME_ABOUT_SUBHEADLINE' />}
            margin='0.5em 0 0.5rem 0'
            center
        />
        {full ?
        <Picture src='schnitt-stoff-schnoffle-v1.jpg' webp='schnitt-stoff-schnoffle-v1.webp' altText='Abbildung Schnitt + Stoff = Schnoff' schnoffle />
        : null }

    </Text>
    );

export default About;



// WEBPACK FOOTER //
// ./src/components/home/About.js